import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { includes, isEmpty } from 'lodash';
import * as R from 'ramda';
import { getGanttEntityLabels } from '@utils/gantt-utils';
import { DropdownFilter, useDropdownFilter } from './base-dropdown-filter';

const EntityFilter = () => {
  const groupType = useSelector(state => state.groups.edit.group.type);

  const getItems = useCallback(
    () => R.values(getGanttEntityLabels(groupType)).map(entity => ({
      id: entity.id,
      name: entity.label
    })),
    [groupType]
  );

  const isChecked = useCallback((selected, item) => includes(selected, item.id), []);

  const {
    items,
    filterChange,
    filterClose,
    getChecked,
    selected
  } = useDropdownFilter({
    name: 'entity',
    getItems,
    multiple: true,
    isChecked
  });

  const renderValue = useCallback(() => {
    if (isEmpty(selected) || selected.length === R.values(getGanttEntityLabels(groupType)).length) {
      return 'All entities';
    }
    return R.values(getGanttEntityLabels(groupType)).find(entity => entity.id === selected[0]).selectedLabel;
  }, [groupType, selected]);

  return (
    <DropdownFilter
      items={items}
      multiple
      filterChange={filterChange}
      filterClose={filterClose}
      renderValue={renderValue}
      getChecked={getChecked}
      selected={selected}
    />
  );
};

export default EntityFilter;
